// PO-13 Poll Create Popup Desktop
import * as tslib_1 from "tslib";
import React from 'react';
import get from 'lodash.get';
import { Formik } from 'formik';
import { withTranslation } from 'react-i18next';
import FormPopup from '../../Popup/Form';
import { getFeature } from '../../DaEditorWrapper/Features';
import { IS_EMPTY_FEATURE } from '../../DaEditorWrapper/Features/isEmpty';
import { convertToServerXhrPayload } from '../../DaEditorWrapper/utils';
import PollEditForm from './PollEditForm';
import { default as PollConfirmationAlert, } from '../PollConfirmationAlert';
import s from './PollEditPopup.scss';
import { withMobileContext } from '../../Context';
var PollEditPopup = /** @class */ (function (_super) {
    tslib_1.__extends(PollEditPopup, _super);
    function PollEditPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            confirmationPopupType: null,
            formikInitialValues: {},
        };
        _this.renderFormPopup = function (formProps) {
            var _a = _this.props, closePollEditModal = _a.closePollEditModal, t = _a.t, isMobile = _a.isMobile;
            var submitForm = formProps.submitForm, dirty = formProps.dirty, setFieldValue = formProps.setFieldValue, values = formProps.values, resetForm = formProps.resetForm;
            var answers = values.answers || [];
            var nonEmptyAnswers = answers.filter(function (answer) { return !_this.isAnswerEmpty(answer); });
            var isSubmittable = nonEmptyAnswers.length >= 2 && values.question;
            return (React.createElement(React.Fragment, null,
                React.createElement(FormPopup, { className: s['root'], isOpen: true, title: t(_this.isNew() ? 'poll.createNew' : 'poll.editPoll'), onSubmit: submitForm, onCancel: dirty ? _this.handleUnsavedClose : closePollEditModal, onClose: dirty
                        ? _this.handleUnsavedClose
                        : function () {
                            resetForm();
                            closePollEditModal();
                        }, cancelBtnLabel: t('common.cancel'), submitBtnLabel: t('common.submit'), disabledSubmit: !isSubmittable, submitTooltip: !isSubmittable &&
                        !isMobile && (React.createElement("div", { className: s['disabled-tooltip'] }, t('poll.errorHint'))), footerExtras: !isSubmittable &&
                        isMobile && (React.createElement("div", { className: s['disabled-tooltip'] }, t('poll.errorHint'))) },
                    React.createElement(PollEditForm, { answers: answers, setFieldValue: setFieldValue })),
                _this.renderConfirmations(resetForm)));
        };
        _this.handleSubmit = function (form) {
            var answers = form.answers.filter(function (answer) { return !_this.isAnswerEmpty(answer); });
            var answersWithEditorData = answers.map(function (answer) {
                var editorData = answer.editorData;
                var editorRaw = convertToServerXhrPayload(editorData.rawContentState, editorData.editorContent, editorData.featuresData);
                return tslib_1.__assign({}, editorRaw, { deviationid: answer.deviation && answer.deviation.deviationId });
            });
            var params = {
                question: form.question,
                answers: answersWithEditorData,
            };
            var deviation = _this.props.deviation;
            if (deviation) {
                var updateParams = tslib_1.__assign({}, params, { pollId: _this.props.deviation.deviationId });
                _this.props.updatePollRequest(updateParams);
            }
            else {
                _this.props.createPollRequest(params);
            }
        };
        _this.handleUnsavedClose = function () {
            _this.setState({
                confirmationPopupType: _this.isNew() ? 'leaveCreating' : 'discardChanges',
            });
        };
        _this.onCancelCloseConfirmation = function () {
            _this.setState({ confirmationPopupType: undefined });
        };
        _this.onConfirmCloseConfirmation = function () {
            _this.setState({ confirmationPopupType: undefined });
            _this.props.closePollEditModal();
        };
        _this.isNew = function () {
            return _this.props.deviation === undefined;
        };
        _this.isAnswerEmpty = function (answer) {
            var deviation = answer.deviation, editorData = answer.editorData, initialEditorData = answer.initialEditorData;
            if (deviation || (initialEditorData && !editorData)) {
                return false;
            }
            if (!editorData || !editorData.featuresData) {
                return true;
            }
            var isEmpty = getFeature(IS_EMPTY_FEATURE, editorData.featuresData);
            return !isEmpty || isEmpty.data.isEmpty;
        };
        _this.validateForm = function (values) {
            var errors = {};
            if (!values.question) {
                errors.question = _this.props.t('poll.missingQuestion');
            }
            return errors;
        };
        return _this;
    }
    PollEditPopup.getDerivedStateFromProps = function (props, state) {
        if (get(state, 'formikInitialValues.question') !== undefined) {
            // already set
            return state;
        }
        var formikInitialValues = {
            question: get(props.deviation, 'poll.question') || '',
            answers: PollEditPopup.getAnswersValueFromDeviation(props.deviation),
        };
        return { formikInitialValues: formikInitialValues };
    };
    PollEditPopup.getAnswersValueFromDeviation = function (deviation) {
        var papiAnswers = get(deviation, 'poll.answers');
        if (!papiAnswers) {
            // If there is no initial data we show two empty answer fields by default
            return [{ id: 1 }, { id: 2 }];
        }
        return papiAnswers.map(function (answer, index) { return ({
            id: index + 1,
            deviation: answer.image,
            initialEditorData: answer.textContent,
        }); });
    };
    PollEditPopup.prototype.render = function () {
        var formikInitialValues = this.state.formikInitialValues;
        return (React.createElement(Formik, { enableReinitialize: true, initialValues: formikInitialValues, onSubmit: this.handleSubmit, validate: this.validateForm, render: this.renderFormPopup }));
    };
    PollEditPopup.prototype.renderConfirmations = function (resetForm) {
        var _this = this;
        return (this.state.confirmationPopupType && (React.createElement(PollConfirmationAlert, { isOpen: true, confirmationType: this.state.confirmationPopupType, onCancel: this.onCancelCloseConfirmation, onConfirm: function () {
                _this.onConfirmCloseConfirmation();
                resetForm();
            } })));
    };
    return PollEditPopup;
}(React.Component));
export { PollEditPopup };
export default withMobileContext(withTranslation()(PollEditPopup));
//# sourceMappingURL=PollEditPopup.js.map